export const state = () => ({
	race_types: [],
});

export const mutations = {
	setRaceTypes(state: any, payload: any) {
		state.race_types = payload;
	},
};

export const getters = {
	getRaceTypes: (state: any) => state.race_types,
};

export const actions = {
	getRaceTypes(state: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/race-types')
				.then((result) => {
					state.commit('setRaceTypes', result.data);
					resolve(result);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
